module.exports = __webpack_public_path__ + "static/media/rings-wedding.cb705161.svg";